// import React from 'react';
// import { UserProvider } from '../src/components/UserContext';
// import UserForm from '../src/components/UserForm';
// import UserList from '../src/components/UserList';

import BlockChain from "./components/BlockChain";

const App = () => {
  return (
    <div> 
   <BlockChain/>
    </div>
  );
};

export default App;
